import React from 'react';
import VideoPlayer from '@/components/video-player';
import styles from './AssetPreviewMedia.module.scss';

interface AssetPreviewMediaProps {
  videoUrl: string | null;
  aspectRatio: number | null;
}

function AssetPreviewMedia({videoUrl, aspectRatio}: AssetPreviewMediaProps) {
  const handleVideoError = (error: unknown) => {
    // eslint-disable-next-line no-console
    console.error('Preview error of video url: ', videoUrl, error);
  };

  const videoPlayerStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    background: 'black',
  };
  if (aspectRatio) {
    videoPlayerStyle.aspectRatio = aspectRatio;
  }
  return (
    <div className={styles.mediaContainer}>
      <VideoPlayer
        containerClassName={styles.videoPlayerContainer}
        url={videoUrl || ''}
        onError={handleVideoError}
        playerStyle={videoPlayerStyle}
        autoPlay
        showOpacityWhenNotPlaying
        playIconCustomStyle={{
          width: '64px',
          height: '64px',
        }}
      />
    </div>
  );
}

export default AssetPreviewMedia;
